import { useEffect } from "preact/hooks";
import { formatISODate, formatISODateTime } from "../helpers";
import { generateSchemaGraph, getBaseUrl } from "../../templateSchemaGraph";

const updateTag = (tagName, attrName, key, valueAttr, value) => {
  let tag = document.querySelector(`head > ${tagName}[${attrName}="${key}"]`);
  if (!tag) {
    tag = document.createElement(tagName);
    document.head.appendChild(tag);
    tag.setAttribute(attrName, key);
  }
  tag.setAttribute(valueAttr, value);
};

const updateMetaTag = (key, content) => {
  const attrName = key.startsWith("og:") ? "property" : "name";
  updateTag("meta", attrName, key, "content", content);
};

const updateLinkTag = (key, href) => {
  updateTag("link", "rel", key, "href", href);
};

const removeTag = (tagName, attrName, key) => {
  const tag = document.querySelector(`head > ${tagName}[${attrName}="${key}"]`);
  if (tag) {
    tag.parentNode.removeChild(tag);
  }
};

const removeMetaTag = (key) => {
  const attrName = key.startsWith("og:") ? "property" : "name";
  removeTag("meta", attrName, key);
};

const removeLinkTag = (key) => {
  removeTag("link", "rel", key);
};

const updateJsonLd = (data) => {
  let script = document.querySelector(
    'head > script[type="application/ld+json"]'
  );
  if (!script) {
    script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    document.head.appendChild(script);
  }

  const schemaGraph = generateSchemaGraph(data);
  script.textContent = JSON.stringify(schemaGraph);
};

const removeJsonLd = () => {
  const script = document.querySelector(
    'head > script[type="application/ld+json"]'
  );
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
};

const Head = ({ data = undefined }) => {
  useEffect(() => {
    if (typeof document !== "undefined") {
      if (data) {
        if (data.title) {
          document.title = data.title;
        }
        if (data.url) {
          updateMetaTag("og:url", `${getBaseUrl()}${data.url}`);
          updateLinkTag("canonical", `${getBaseUrl()}${data.url}`);
        } else if (!data.is404) {
          removeMetaTag("og:url");
          removeLinkTag("canonical"); // Ideally it would set to root of site
        }
        if (data.og_type) {
          updateMetaTag("og:type", data.og_type);
        } else {
          removeMetaTag("og:type");
        }
        if (data.og_image) {
          updateMetaTag("og:image", `${getBaseUrl()}${data.og_image}`);
        } else {
          removeMetaTag("og:image");
        }
        if (data.og_title) {
          updateMetaTag("og:title", data.og_title);
        } else {
          removeMetaTag("og:title");
        }
        if (data.og_description) {
          updateMetaTag("og:description", data.og_description);
        } else {
          removeMetaTag("og:description");
        }
        if (data.description) {
          updateMetaTag("description", data.description);
        } else {
          removeMetaTag("description");
        }
        if (data.datePublished) {
          updateMetaTag(
            "article:published_time",
            formatISODateTime(data.datePublished)
          );
        } else {
          removeMetaTag("article:published_time");
        }
        if (data.dateModified) {
          updateMetaTag(
            "article:modified_time",
            formatISODateTime(data.dateModified)
          );
          updateMetaTag(
            "article:updated_time",
            formatISODateTime(data.dateModified)
          );
          updateMetaTag("date", formatISODate(data.dateModified));
        } else {
          removeMetaTag("article:modified_time");
          removeMetaTag("article:updated_time");
          removeMetaTag("date");
        }

        // Shared JSON-LD Updater
        updateJsonLd(data);
      } else {
        removeJsonLd();
      }

      if (typeof gtag !== "undefined") {
        // Send GA4 (Google Analytics) page view
        gtag("event", "page_view");
      }
    }
  }, [data]);
  return null;
};

export default Head;
